module.exports = __webpack_public_path__ + "img/logo_koehnke_dark_bg.fb0a1e2d.png";